import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-delete-icon',
    templateUrl: './delete-icon.component.html',
    styleUrls: ['./delete-icon.component.scss']
})
export class DeleteIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 20;
    }
}
